var React = require('react');

function CreateIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18.257,6.671l-12.664,12.664c-0.119,0.119 -0.206,0.266 -0.253,0.428l-2.3,7.899c-0.102,0.349 -0.006,0.725 0.25,0.984c0.256,0.258 0.631,0.357 0.981,0.258l7.957,-2.242c0.165,-0.047 0.315,-0.135 0.436,-0.256l12.664,-12.664l-7.071,-7.071Zm1.414,-1.414l7.071,7.071l1.793,-1.792c0.938,-0.938 1.465,-2.21 1.465,-3.536c-0,-1.326 -0.527,-2.598 -1.465,-3.536c0,0 0,0 0,0c-0.938,-0.937 -2.209,-1.464 -3.535,-1.464c-1.327,0 -2.598,0.527 -3.536,1.464l-1.793,1.793Z","key":0}),React.createElement("g",{"id":"Icon","key":1})]);
}

CreateIcon.defaultProps = {"fill":"currentColor","viewBox":"0 0 32 32","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"version":"1.1","xmlSpace":"preserve"};

module.exports = CreateIcon;

CreateIcon.default = CreateIcon;
